import { map } from 'rxjs';

// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AttachmentDto, PreTestingDto, TestingDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class TestingApiClient extends BaseCRUDApiClient<TestingDto> {
  baseUrl = this.config.apiEndpoint + '/testing';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  getBySupplierId(supplierId: string) {
    return this.http.get<TestingDto[]>(
      `${this.baseUrl}/bySupplierId/${supplierId}`,
    );
  }

  updatePreTesting(entity: Partial<PreTestingDto>) {
    return this.http.put<TestingDto>(
      `${this.baseUrl}/pre-testing/${entity.id}`,
      entity,
    );
  }

  createPreTestingFromOrder(
    email: string,
    attachments: AttachmentDto[],
    entity: Partial<TestingDto>,
  ) {
    return this.http.post<TestingDto>(
      `${this.baseUrl}/create-pre-testing-from-order`,
      { ...entity, email, attachments },
    );
  }

  sendPreTestingLink(id: string, email: string, attachments: AttachmentDto[]) {
    return this.http.post(`${this.baseUrl}/send-pre-testing-link`, {
      id,
      email,
      attachments,
    });
  }

  updateTestingStatus(id: string, testingStatusCode: string) {
    return this.http.post<TestingDto>(`${this.baseUrl}/update-testing-status`, {
      id,
      testingStatusCode,
    });
  }

  createReport(id: string, firme: number) {
    return this.http
      .post(
        `${this.baseUrl}/create-testing-module`,
        { id: id, firme: firme },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  saveReport(id: string, firme: number) {
    return this.http.post(`${this.baseUrl}/save-testing-module`, {
      id: id,
      firme: firme,
    });
  }
}
